<template>
  <DragDialog
    title="移动到"
    :width="400"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel">
    <div class="common-tree-box">
      <el-tree
        class="dialog-tree-primary"
        ref="moveTree"
        :data="data"
        :props="defaultProps"
        node-key="nodeId"
        highlight-current
        :expand-on-click-node="false"
        :default-expand-all="true"
        @node-click="handleNodeClick">
      </el-tree>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'

import { Store } from '@/utils/store'

import {
  publicElemCatalogService,
  publicElemMoveNodeService,
  publicElemBatchMoveNodeService,
  privateElemCatalogService,
  privateElemMoveNodeService,
  privateElemBatchMoveNodeService
} from '@/service/interface'
export default {
  data() {
    return {
      catalogRootId: '00000000-0000-0000-0000-000000000000',
      data: [],
      defaultProps: {
        children: 'nodes',
        label: 'nodeName'
      }
    }
  },
  props: {
    visible: Boolean,
    type: String,
    userId: String,
    currNode: Object,
    elemsToMove: Array,
    initCatalog: Function,
    updateDataList: Function,
    closeDialog: Function
  },
  components: {
    DragDialog
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initData()
      }
    }
  },
  methods: {
    initData() {
      return new Promise(resolve => {
        if (this.type === 'PublicElem') {
          let params = {
            parentId: this.catalogRootId,
            returnCount: false,
            lazyLoading: false
          }
          publicElemCatalogService(params).then(response => {
            if (response.isSuccess) {
              let data = response.data
              let catalogData = [
                {
                  nodeId: this.catalogRootId,
                  nodeName: '公共构件',
                  nodeType: { value: 0, displayName: '根节点' },
                  count: data.count,
                  nodes: data.nodes
                }
              ]
              this.data = catalogData
              resolve()
            } else {
              this.$message.error(response.errMsg)
            }
          })
        } else {
          let userInfo = Store.userInfo
          let userId = this.userId ? this.userId : userInfo.userId
          let params = {
            parentId: this.catalogRootId,
            userId,
            returnCount: false,
            lazyLoading: false
          }
          privateElemCatalogService(params).then(response => {
            if (response.isSuccess) {
              let data = response.data
              let catalogData = [
                {
                  nodeId: this.catalogRootId,
                  nodeName: '我的构件',
                  nodeType: { value: 0, displayName: '根节点' },
                  count: data.count,
                  nodes: data.nodes
                }
              ]
              this.data = catalogData
              resolve()
            } else {
              this.$message.error(response.errMsg)
            }
          })
        }
      })
    },
    handleNodeClick(nodeData) {
      this.targetNode = nodeData
    },
    submit() {
      if (this.elemsToMove.length === 1) {
        let nodeId = this.elemsToMove.map(el => el.dataSetId)[0]
        let params = {
          targetNodeId: this.targetNode.nodeId,
          nodeId
        }
        if (this.type === 'PublicElem') {
          publicElemMoveNodeService(params).then(response => {
            if (response.isSuccess) {
              let nodeData = {
                nodeId: this.catalogRootId
              }
              this.initCatalog(nodeData).then(() => {
                this.updateDataList()
                this.$message.success('移动成功')
                this.closeDialog()
              })
            } else {
              this.$message.error(response.errMsg)
            }
          })
        } else {
          privateElemMoveNodeService(params).then(response => {
            if (response.isSuccess) {
              let nodeData = {
                nodeId: this.catalogRootId
              }
              this.initCatalog(nodeData).then(() => {
                this.updateDataList()
                this.$message.success('移动成功')
                this.closeDialog()
              })
            } else {
              this.$message.error(response.errMsg)
            }
          })
        }
      } else {
        let nodes = this.elemsToMove.map(el => el.dataSetId)
        let params = {
          targetNodeId: this.targetNode.nodeId,
          nodes
        }
        if (this.type === 'PublicElem') {
          publicElemBatchMoveNodeService(params).then(response => {
            if (response.isSuccess) {
              let nodeData = {
                nodeId: this.catalogRootId
              }
              this.initCatalog(nodeData).then(() => {
                this.updateDataList()
                this.$message.success('移动成功')
                this.closeDialog()
              })
            } else {
              this.$message.error(response.errMsg)
            }
          })
        } else {
          privateElemBatchMoveNodeService(params).then(response => {
            if (response.isSuccess) {
              let nodeData = {
                nodeId: this.catalogRootId
              }
              this.initCatalog(nodeData).then(() => {
                this.updateDataList()
                this.$message.success('移动成功')
                this.closeDialog()
              })
            } else {
              this.$message.error(response.errMsg)
            }
          })
        }
      }
    },
    cancel() {
      this.closeDialog()
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.common-tree-box {
  color: var(--default-color);
  max-height: 500px;
  overflow: auto;

  :deep(.el-tree){
    background: none;
  }

  .icon {
    color: var(--icon-color);
    font-size: 16px;
    margin-right: 10px;
    vertical-align: middle;
  }
}
</style>
